export const convertToNumber = (numberString) => {
    return String(numberString) === '' ? 0 : parseFloat(String(numberString).replace(',', '.'));
};
